import {
  Component,
  ChangeDetectionStrategy,
  Input,
  Output,
  ElementRef,
  AfterViewInit,
  OnDestroy,
  EventEmitter,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { SVGIconComponentsModule } from 'src/app/common/svg-icon/svg-icon-components.module';
import { TranslateModule } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-pdf-hidden-page',
  templateUrl: './hidden-page.component.html',
  styleUrls: ['./hidden-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, SVGIconComponentsModule, TranslateModule],
})
export class HiddenPageComponent implements AfterViewInit, OnDestroy {
  @Input() static = false;
  @Input() isLoading = false;
  // This is just to have a uniform interface for all angular components used in a board item, not used for now.
  @Input() state!: any;
  @Output() stateChanged = new EventEmitter<any>();

  readonly iconHeight$ = new BehaviorSubject<number>(0);
  private resizeObserver: ResizeObserver;

  constructor(private el: ElementRef) {
    this.resizeObserver = new ResizeObserver(() => {
      const height = this.el.nativeElement.offsetHeight;
      this.iconHeight$.next(Math.floor(height * 0.25));
    });
  }

  ngAfterViewInit() {
    this.resizeObserver.observe(this.el.nativeElement);
  }

  ngOnDestroy() {
    this.resizeObserver.disconnect();
    this.iconHeight$.complete();
  }
}
